/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the type of time interval to consider to aggregate the values:
 *   * SECOND : second
 *   * MINUTE : minute
 *   * HOUR: hour
 *   * DAY: day
 */
export enum DataTimeStepType {
  SECOND = 'SECOND',
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY'
}
